export enum ChatConversationType {
    Direct = 0,
    Group = 1,
    Ai = 2,
    System = 3
}

export enum ChatMessageType {
    Text = 0,
    System = 1,
    Ai = 2
}

export interface ChatConversationDto {
    id: string;
    title: string;
    type: ChatConversationType;
    lastMessageAt: string;
    unreadCount: number;
    lastMessagePreview: string;
    memberIds: string[];
}

export interface ChatMessageDto {
    id: string;
    conversationId: string;
    senderId: string;
    senderName?: string;
    senderAvatar?: string;
    type: ChatMessageType;
    body: string;
    isImportant: boolean;
    isEdited: boolean;
    isDeleted: boolean;
    createdAt: string;
}

export interface ChatMessagesPageDto {
    skip: number;
    take: number;
    totalCount: number;
    items: ChatMessageDto[];
}

export interface ChatCreateConversationRequest {
    type: ChatConversationType;
    title: string;
    memberIds: string[];
}

export interface ChatSendMessageRequest {
    conversationId: string;
    body: string;
    isImportant: boolean;
    type: ChatMessageType;
}

export interface ChatReadEvent {
    conversationId: string;
    userId: string;
    readAt: string;
}

export interface ChatTypingEvent {
    conversationId: string;
    userId: string;
    userName?: string;
}

export interface SimpleUserDto {
    id: string;
    name: string;
    avatar?: string;
}
